import { Card } from '@fabric-ds/react';
import isEmpty from 'lodash.isempty';
import React from 'react';
import { useContentModuleDataContext } from '../helpers/DataContext';
import { trackEventViewCustomerContent } from '../helpers/tracking';
import { ModuleCardProps } from '../types';

function ModuleCard({ moduleData, index }: ModuleCardProps) {
  const { imageHost, adId, trackingContext } = useContentModuleDataContext();
  const { description, heading, url, urlText, image } = moduleData;

  const imagePath = !isEmpty(image) ? `${imageHost}/dynamic/480x480c/${image.path}` : '';

  return (
    <Card flat>
      <img className="h-fit w-full object-cover" src={imagePath} alt={`Bilde ${index + 1}`} />
      <div className="p-16">
        <h4>{heading}</h4>
        <p>{description}</p>
        {!isEmpty(url) && (
          <a
            id="module-link"
            href={url}
            rel="noopener nofollow noreferrer external"
            target="_blank"
            onClick={() => trackEventViewCustomerContent(adId, trackingContext)}
          >
            {urlText || url}
          </a>
        )}
      </div>
    </Card>
  );
}

function ContentModule() {
  const { contentModule } = useContentModuleDataContext();

  if (contentModule) {
    const { heading, modules } = contentModule;

    return (
      <div className="pt-64 pb-32">
        {heading && <h3 className="mb-32">{heading}</h3>}
        <div className="grid grid-cols-1 gap-32 sm:grid-cols-3">
          {modules.map((module, index) => (
            <ModuleCard moduleData={module} key={module.heading} index={index} />
          ))}
        </div>
      </div>
    );
  }
}

export default ContentModule;
